import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '@/lib/axios';
import { Guest, CreateGuestDTO } from '@/types/guest.types';

export interface GuestsParams {
  search?: string;
  page?: number;
}

interface RawGuestsResponse {
  success: boolean;
  data: {
    guests: {
      data: Guest[];
      current_page: number;
      last_page: number;
      total: number;
      per_page: number;
    };
  };
}

export const useGuestsQuery = (params?: GuestsParams) => {
  return useQuery({
    queryKey: ['guests', params],
    queryFn: async (): Promise<Guest[]> => {
      const { data } = await api.get<RawGuestsResponse>('/v1/hospedes', {
        params,
      });
      return data.data?.guests?.data ?? [];
    },
    enabled: true,
  });
};

export const useCreateGuestMutation = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (payload: CreateGuestDTO) => {
      const { data } = await api.post<{ success: boolean; data: Guest }>('/v1/hospedes', payload);
      return data.data;
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['guests'] });
    },
  });
};
